<script>

    import StatisticsService from '../$services/statistics.service'
    import NumeralMethods from '../$methods/numeral.methods'
    import StatsCard from '../$components/stats.card.svelte'

    export let dateStart = null
    export let dateEnd = null

    let value = NumeralMethods.cash(0)
    let change = 0
    let sparkline = []

    $: load(dateStart, dateEnd)

    async function load(start, end) {
        if (!start || !end) return

        const res = await StatisticsService.getShipmentsProfit({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        const data = res?.data
        if (!data) return

        value = NumeralMethods.cash(data.value ?? 0)
        change = data.change ?? 0
        sparkline = data.sparkline ?? []
    }

</script>

<StatsCard
    icon="fas fa-chart-line"
    title="Utilidad"
    { value }
    { change }
    { sparkline }
/>
